/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Focus_Pass_Paywall_CaptionInputs */

const en_focus_pass_paywall_caption = /** @type {(inputs: Focus_Pass_Paywall_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus or not, unlocked Land Style is yours.`)
};

const ar_focus_pass_paywall_caption = /** @type {(inputs: Focus_Pass_Paywall_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سواء كان لديك Plus أم لا، ستحتفظ بـ نمط الأرض الذي فتحته.`)
};

const de_focus_pass_paywall_caption = /** @type {(inputs: Focus_Pass_Paywall_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ob mit oder ohne Plus, du behältst Land-Stil, sobald es freigeschaltet ist.`)
};

const es_focus_pass_paywall_caption = /** @type {(inputs: Focus_Pass_Paywall_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con o sin Plus, conservarás Estilo de terreno que hayas desbloqueado.`)
};

const fr_focus_pass_paywall_caption = /** @type {(inputs: Focus_Pass_Paywall_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec ou sans Plus, vous conservez Style de sol que vous avez débloqué.`)
};

const it_focus_pass_paywall_caption = /** @type {(inputs: Focus_Pass_Paywall_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con o senza Plus, manterrai Stile del terreno che hai sbloccato.`)
};

const ja_focus_pass_paywall_caption = /** @type {(inputs: Focus_Pass_Paywall_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusの有無にかかわらず、アンロックしたランドスタイルは永久に保持されます。`)
};

const ko_focus_pass_paywall_caption = /** @type {(inputs: Focus_Pass_Paywall_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 여부와 관계없이, 잠금 해제된 랜드 스타일은(는) 영구 소장됩니다.`)
};

const pt_br_focus_pass_paywall_caption = /** @type {(inputs: Focus_Pass_Paywall_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com ou sem Plus, você mantém Estilo de terreno que desbloqueou.`)
};

const ru_focus_pass_paywall_caption = /** @type {(inputs: Focus_Pass_Paywall_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С подпиской Plus или без нее, вы навсегда сохраните разблокированный Стиль земли.`)
};

const th_focus_pass_paywall_caption = /** @type {(inputs: Focus_Pass_Paywall_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ว่าจะมี Plus หรือไม่ คุณก็จะได้เป็นเจ้าของ สไตล์ผืนดิน ที่ปลดล็อกแล้วตลอดไป`)
};

const tr_focus_pass_paywall_caption = /** @type {(inputs: Focus_Pass_Paywall_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus olsun ya da olmasın, kilidini açtığın Arazi Türü senin kalır.`)
};

const zh_cn_focus_pass_paywall_caption = /** @type {(inputs: Focus_Pass_Paywall_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`土地皮肤解锁后永久保留，Plus 会员结束不收回。`)
};

const zh_tw_focus_pass_paywall_caption = /** @type {(inputs: Focus_Pass_Paywall_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`土地造型解鎖後永久保留，Plus 結束不收回。`)
};

/**
* | output |
* | --- |
* | "Plus or not, unlocked Land Style is yours." |
*
* @param {Focus_Pass_Paywall_CaptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const focus_pass_paywall_caption = /** @type {((inputs?: Focus_Pass_Paywall_CaptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Focus_Pass_Paywall_CaptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_focus_pass_paywall_caption(inputs)
	if (locale === "ar") return ar_focus_pass_paywall_caption(inputs)
	if (locale === "de") return de_focus_pass_paywall_caption(inputs)
	if (locale === "es") return es_focus_pass_paywall_caption(inputs)
	if (locale === "fr") return fr_focus_pass_paywall_caption(inputs)
	if (locale === "it") return it_focus_pass_paywall_caption(inputs)
	if (locale === "ja") return ja_focus_pass_paywall_caption(inputs)
	if (locale === "ko") return ko_focus_pass_paywall_caption(inputs)
	if (locale === "pt_br") return pt_br_focus_pass_paywall_caption(inputs)
	if (locale === "ru") return ru_focus_pass_paywall_caption(inputs)
	if (locale === "th") return th_focus_pass_paywall_caption(inputs)
	if (locale === "tr") return tr_focus_pass_paywall_caption(inputs)
	if (locale === "zh_cn") return zh_cn_focus_pass_paywall_caption(inputs)
	return zh_tw_focus_pass_paywall_caption(inputs)
});